export default "__VITE_ASSET__f8f919d4__"